import './SideBar.css';
import { Col, Row } from 'reactstrap';
import { Outlet, Route, Router, Routes } from 'react-router-dom';
import NavBar from '../NavBar/NavBar.js';

const SideBar = (props) => {

  
  return (
    <>
    {/* <Header/> */}
  <Row>
    <Col md={3} xs={12}><NavBar/></Col>
    <Col md={9} xs={12} className="mt-3"> <Outlet />
      </Col>
  </Row></>
  );
};

SideBar.propTypes = {};

SideBar.defaultProps = {};

export default SideBar;
